export default ({ monitorByLevel, clarifySpeed, dailyBuzz, rateCardPartTime, rateCardFullTime }) => {
  if (dailyBuzz && clarifySpeed && clarifySpeed) {
    return ((clarifySpeed + (clarifySpeed * 1 / 3600 * dailyBuzz)) * 0.75 * rateCardFullTime) + ((monitorByLevel + (clarifySpeed * 1 / 3600 * dailyBuzz)) * 0.25 * rateCardPartTime);
  }
  return 0;
};
